import React, { ComponentProps } from 'react';
import cn from 'clsx';
import { TextButton } from '@wix/wix-ui-tpa/cssVars';
import { classes } from './styles.st.css';

export const TextButtonComponent = (
  props: ComponentProps<typeof TextButton>,
) => (
  <TextButton {...props} className={cn(classes.textButton, props.className)} />
);
